import { Fragment, useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { ILanding, ILandingCanvas, ILandingContent, ILandingFloat, ILandingPrimitive, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { LANDING_TYPE_CONTENT } from "../../../data/interfaces"


/* Protopia Ecosystem component */
export interface IContentBreadcrumbsProps {
   sectionId:ID
   contentId:ID
}
const ContentBreadcrumbs = (props: IContentBreadcrumbsProps): JSX.Element => {
    const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const [section, setSection] = useState<ILandingSection>({} as ILandingSection)
    const [content, setContent] = useState<ILandingContent>({} as ILandingContent)
    useEffect(() => {
        const section: ILandingSection | undefined      = currentLanding.sections.find(section => section.id === props.sectionId )
        
        console.log( props.sectionId, section )
        
        if(section) {
            setSection( section )
            const content: ILandingContent | undefined  = section.data.find((data: ILandingContent) => data.id === props.contentId )
            if(content) {
                setContent( content )
            }
        }
    }, [ props, currentLanding ])

    return <Breadcrumbs content={content} /> 
}
export default ContentBreadcrumbs

interface IBreadcrumbsProps {
    content: ILandingContent
}
const Breadcrumbs = (props: IBreadcrumbsProps) : JSX.Element => {
    
    //console.log( props.content )
    
    switch(props.content.type) {
        case LANDING_TYPE_CONTENT.CANVAS: 
            const floats = ({ ...props.content } as unknown as ILandingCanvas).floats
            return <div className='landing-content-breadcrumbs mx-3'>
                {
                    floats
                        .filter(float => !!float && float.primitives)
                        .map((float: ILandingFloat, i) => {
                             return <Fragment key={ i }> 
                                <span className="d-flex small">
                                    {
                                        ( float.primitives || [] )
                                            .filter(primitives => !!primitives)
                                            .map((primitive: ILandingPrimitive, ii ) => {
                                                return <div className="landing-data-panel-btn px-2 text-nowrap small" key={ ii }>
                                                    <span>
                                                        { primitive.type }
                                                    </span>
                                                </div>
                                            })
                                    }
                                </span> 
                            </Fragment>

                            
                        })
                }
            </div>
        default:
            return <></>
    }
}